helpers = require('../../helpers.coffee')
module.exports = {
  methods:
    closeDropdown: ->
      EventsBus.$emit 'NotificationDropdown::Close'

    remove: ->
      @$emit 'remove-notification', @notification.id

    navigate: ->
      @remove()
      event.originalEventName = 'navigate'
      @$emit event.originalEventName, { event }
      return unless @go_to
      (new NotificationsResource()).read(null, @unknownError, { id: @notification.id })
      @$router.push(@go_to)
      @closeDropdown()

    ransack_contact_ids: (key)->
      contact_ids = @notification.metadata.contact_ids
      contact_ids = Array.from(new Set(contact_ids)) # uniq
      "#{key}=#{contact_ids}"

  computed:
    name: ->
      if @manager_and_not_owner && @notification
        @notification?.user?.name || 'Você'
      else
        'Você'

    manager_and_not_owner: ->
      @notification && @current_user.isManager() && @current_user.id != @notification.user?.id

  created: ->
    @current_user = Session.current_user
}



// WEBPACK FOOTER //
// ./src/helpers/notifications/kind_wrapper.coffee